export const FEATURE = {
	PROFESSIONALS: 'PROFESSIONALS',
	FLEX_PROFESSIONALS: 'FLEX_PROFESSIONALS'
};

export default FEATURE;
